/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  PurchasedGoodsImportError,
  PurchasedGoodsImportRequest
} from '../../types'
import { apiClient } from '../../client';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Root errors come from the serializer; once the root is valid, the file then the rows are checked before anything is stored.
 */
export const activityImportsPurchasedGoodsCreate = (
    purchasedGoodsImportRequest: PurchasedGoodsImportRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/activity-imports/purchased-goods`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: purchasedGoodsImportRequest
    },
      options);
    }
  


export const getActivityImportsPurchasedGoodsCreateMutationOptions = <TError = PurchasedGoodsImportError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>, TError,{data: PurchasedGoodsImportRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>, TError,{data: PurchasedGoodsImportRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>, {data: PurchasedGoodsImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  activityImportsPurchasedGoodsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivityImportsPurchasedGoodsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>>
    export type ActivityImportsPurchasedGoodsCreateMutationBody = PurchasedGoodsImportRequest
    export type ActivityImportsPurchasedGoodsCreateMutationError = PurchasedGoodsImportError

    export const useActivityImportsPurchasedGoodsCreate = <TError = PurchasedGoodsImportError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>, TError,{data: PurchasedGoodsImportRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof activityImportsPurchasedGoodsCreate>>,
        TError,
        {data: PurchasedGoodsImportRequest},
        TContext
      > => {

      const mutationOptions = getActivityImportsPurchasedGoodsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    